<template>
	<div
		class="container d-flex justify-center align-center"
		style="height: 100vh"
	>
		<v-progress-circular
			color="secondary"
			size="140"
			indeterminate
		/>
		<v-progress-circular
			color="secondary"
			size="110"
			width="20"
			style="position: absolute"
		/>
		<v-progress-circular
			color="secondary"
			size="70"
			indeterminate
			style="position: absolute"
		/>
	</div>
</template>

<script>
export default {
	name: 'PageLoader',
	mounted() {
		document.onreadystatechange = () => {
			if (document.readyState === 'complete') {
				this.isLoader = true;
			}
		};
	},
};
</script>

<style lang="scss">
.loading-overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgb(255, 255, 255);
	color: var(--bs-primary);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 5;
}
</style>
